module.exports = __webpack_public_path__ + "img/preview-21.05af20ec.webp";